<html>
    <head></head>
    <body>
        <div class="fourNotFour" >404</div>
        <h1 class="pageNotFound" >Page Not Found</h1>
    </body>

</html>